<div class="wb-summary-page wb-{{layout}}" #summaryPane>
  <div class="wb-col-left">
    <h3 class="wb-page-title">{{'form_input_'+$safeNavigationMigration(parts[selectedIndex]?.title) | translate | ucFirst}}</h3>

    <div class="wb-summary-wrapper">
      <div class="wb-summary-card">
        <div class="wb-summary-top">
          <div class="wb-summary-image">
            <img
              [src]="formGroup.controls['product']?.value?.imagePath || '/assets/default-product-paypal.png'"
              alt="{{formGroup.controls['product']?.value?.descriptionTag}}"
              />
            </div>

            <div class="wb-summary-details">
              <div class="wb-summary-row">
                <span class="wb-label">
                  {{ activeTab === 'hourly'
                  ? ('hourly_bookings' | translate | ucFirst)
                  : formGroup.controls.returnTrip?.value
                  ? ('return_trip' | translate | ucFirst)
                  : ('one_way_trip' | translate | ucFirst)
                  }}
                  {{ $safeNavigationMigration(formGroup.controls['product']?.value?.descriptionTag) | translate | ucFirst }}
                </span>
                @if (!isMetered) {
                  <span class="wb-value">
                    {{
                    (formGroup.controls.returnTrip?.value
                    ? $safeNavigationMigration(formGroup.controls['product']?.value?.totalPrice?.total)
                    : $safeNavigationMigration(formGroup.controls['product']?.value?.price?.total)
                    ) / 100 | currency:this._state.currency:'symbol':'1.2-2'
                    }}
                  </span>
                }
              </div>

              @for (row of summaryProductRows; track trackBySku($index, row)) {
                <div class="wb-summary-row">
                  <span class="wb-label">{{ row.label | translate | ucFirst }}</span>
                  @if (!isMetered) {
                    <span class="wb-value">
                      {{ row.total / 100 | currency:this._state.currency:'symbol':'1.2-2' }}
                    </span>
                  }
                  @if (isMetered) {
                    <span class="wb-value">—</span>
                  }
                </div>
              }

              @if (_state.couponDiscount?.id && couponDiscountTotal < 0) {
                <div class="wb-summary-row">
                  <span class="wb-label">{{ 'coupon_discount' | translate | ucFirst }}</span>
                  <span class="wb-value">{{ couponDiscountTotal / 100 | currency:this._state.currency:'symbol':'1.2-2' }}</span>
                </div>
              }
            </div>
          </div>

          <div class="wb-summary-total">
            @if (!isMetered && _state.couponDiscount?.id && couponDiscountTotal < 0) {
              <div class="wb-summary-subtotal">
                <span class="wb-label">{{ 'subtotal' | translate | ucFirst }}</span>
                <span class="wb-value">{{ subtotal / 100 | currency:this._state.currency:'symbol':'1.2-2' }}</span>
              </div>
            }
            @if (!isMetered && totalVat && totalVat > 0 && !hideVat) {
              <div class="wb-summary-vat">
                <span class="wb-label">{{ 'vat' | translate | ucFirst }} {{vatPercentage}}%</span>
                <span class="wb-value">{{ totalVat / 100 | currency:this._state.currency:'symbol':'1.2-2' }}</span>
              </div>
            }
            <div class="wb-summary-grandtotal">
              @if (!isMetered) {
                <span class="wb-label">{{ 'total_price' | translate | ucFirst }}</span>
                <span class="wb-value">{{ totalPrice / 100 | currency:this._state.currency:'symbol':'1.2-2' }}</span>
              }
              @if (isMetered) {
                <span class="wb-metered-price">{{ 'Price calculated on meter' | translate }}</span>
              }
            </div>
          </div>
        </div>
      </div>

      <div [class]="(!formGroup.controls['product']?.value?.price?.total ? 'no-price' : '')">
        @for (part of parts; track part) {
          @for (field of part.fieldsWithLayoutInfo; track field; let fi = $index) {
            @if (part.type === 'summary') {
              <app-field-wrapper
                [className]="'wb-field wb-'+field.type"
                [index]="fi"
                [layout]="layout"
                [field]="field"
                [form]="form"
                (openHelpModal)="toggleHelpModal($event)"
              [formGroup]="formGroup"></app-field-wrapper>
            }
          }
        }
      </div>

    </div><!-- /wb-col-left -->

    <div class="wb-col-right">
      @if (hasCollapsibleContent) {
        <div class="wb-details-container" [class.wb-details-open]="detailsOpen" #detailsContainer>
          <div class="wb-details-inner" #detailsInner>
            @for (partIndex of orderedSummaryIndices; track partIndex) {
              @if (parts[partIndex]?.type !== 'summary' && parts[partIndex]?.type !== 'products') {
                <div class="wb-chapter wb-{{parts[partIndex]?.type}}"
                  >
                  <div class="wb-fields">
                    @for (field of sortedPartFields($safeNavigationMigration(parts[partIndex]?.fields)); track field) {
                      <div class="wb-field wb-summary-field-{{field.type}}">
                        @if (field.type !== 'collapse' &&
                          (field.type !== 'sortable-address' || formGroup.controls[field.property]?.value.length > 0) &&
                          (formGroup.controls[field.property]?.value !== 0 && formGroup.controls[field.property]?.value !== '')) {
                          <div class="wb-name"
                            >
                            {{(field.label ? field.label : field.placeholder) | translate | ucFirst}}
                          </div>
                        }
                        @if (field.type !== 'collapse' && formGroup.controls[field.property]?.value !== 0 &&
                          formGroup.controls[field.property]?.value !== '') {
                          <div>
                            <app-field-value [field]="field" [form]="form" [formGroup]="formGroup"></app-field-value>
                          </div>
                        }
                        @for (field of field.fields; track field) {
                          <div class="wb-field wb-summary-field-{{field.type}}">
                            @if (field.type !== 'collapse' && formGroup.controls[field.property]?.value !== 0 &&
                              formGroup.controls[field.property]?.value !== '') {
                              <div class="wb-name"
                                >
                                {{field.label | translate | ucFirst}}
                              </div>
                            }
                            <app-field-value [field]="field" [form]="form" [formGroup]="formGroup"></app-field-value>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
              @if (parts[partIndex]?.returnIndex && formGroup.controls.returnTrip?.value) {
                <div class="wb-chapter wb-chapter-return wb-{{parts[partIndex]?.type}}"
                  >
                  <h4>{{'return_trip' | translate | ucFirst}}</h4>
                  <div class="wb-fields">
                    <app-field-wrapper [className]="'wb-field wb-summary wb-address'"
                      [summary]="true"
                      [index]="9999"
                      [form]="form"
                      [layout]="layout"
                      [field]="returnDepartureField"
                      (openHelpModal)="toggleHelpModal($event)"
                    [formGroup]="formGroup"></app-field-wrapper>
                    <app-field-wrapper [className]="'wb-field wb-summary wb-address'"
                      [summary]="true"
                      [index]="9999"
                      [form]="form"
                      [layout]="layout"
                      [field]="returnDestinationField"
                      (openHelpModal)="toggleHelpModal($event)"
                    [formGroup]="formGroup"></app-field-wrapper>
                    @for (field of parts[parts[partIndex]?.returnIndex]?.fields; track field) {
                      <div class="wb-field">
                        @if (field.type !== 'collapse' &&
                          (field.type !== 'sortable-address' || formGroup.controls[field.property]?.value.length > 0) &&
                          (formGroup.controls[field.property]?.value !== 0 && formGroup.controls[field.property]?.value !== '')) {
                          <div class="wb-name"
                            >
                            {{(field.label ? field.label : field.placeholder) | translate | ucFirst}}
                          </div>
                        }
                        @if (field.type !== 'collapse' && formGroup.controls[field.property]?.value !== 0 &&
                          formGroup.controls[field.property]?.value !== '') {
                          <div>
                            <app-field-value [field]="field" [form]="form" [formGroup]="formGroup"></app-field-value>
                          </div>
                        }
                        @for (field of field.fields; track field) {
                          <div class="wb-field">
                            @if (field.type !== 'collapse' && formGroup.controls[field.property]?.value !== 0 &&
                              formGroup.controls[field.property]?.value !== '') {
                              <div class="wb-name"
                                >
                                {{field.label | translate | ucFirst}}
                              </div>
                            }
                            <app-field-value [field]="field" [form]="form" [formGroup]="formGroup"></app-field-value>
                          </div>
                        }
                      </div>
                    }
                    @for (field of returnLegFields(partIndex); track field) {
                      <div class="wb-field">
                        <div class="wb-name">{{(field.label ? field.label : field.placeholder) | translate | ucFirst}}</div>
                        <app-field-value [field]="field" [form]="form" [formGroup]="formGroup"></app-field-value>
                      </div>
                    }
                  </div>
                </div>
              }
            }
          </div>
          @if (detailsOverflowing) {
            <div class="wb-details-fade"></div>
          }
          @if (detailsOverflowing) {
            <button class="wb-details-toggle" (click)="detailsOpen = !detailsOpen">
              {{ (detailsOpen ? 'close' : 'open') | translate | ucFirst }} {{ 'details' | translate }}
            </button>
          }
        </div>
      }
    </div><!-- /wb-col-right -->
  </div>

  <ngx-smart-modal [identifier]="summaryDialogId" customClass="nsm-dialog-animation-ttb wb-booking-summary-dialog">
    <span class="wb-close" (click)="modalService.getModal(summaryDialogId).close()"></span>
    <h3>{{ 'view_booking_summary' | translate | ucFirst }}</h3>

    <div class="wb-dialog-summary-content">
      @for (partIndex of parts[index]?.summary; track partIndex) {
        @if (parts[partIndex]?.type !== 'summary' && parts[partIndex]?.type !== 'products') {
          <div class="wb-chapter wb-open wb-{{parts[partIndex]?.type}}"
            >
            @if (parts[partIndex]?.title) {
              <h4>{{$safeNavigationMigration(parts[partIndex]?.title) | translate | ucFirst}}</h4>
            }
            <div class="wb-fields">
              @for (field of parts[partIndex]?.fields; track field) {
                <div class="wb-field">
                  @if (field.type !== 'collapse' &&
                    (field.type !== 'sortable-address' || formGroup.controls[field.property]?.value.length > 0) &&
                    (formGroup.controls[field.property]?.value !== 0 && formGroup.controls[field.property]?.value !== '')) {
                    <div class="wb-name"
                      >
                      {{(field.label ? field.label : field.placeholder) | translate | ucFirst}}
                    </div>
                  }
                  @if (field.type !== 'collapse' && formGroup.controls[field.property]?.value !== 0 &&
                    formGroup.controls[field.property]?.value !== '') {
                    <div>
                      <app-field-value [field]="field" [form]="form" [formGroup]="formGroup"></app-field-value>
                    </div>
                  }
                  @for (field of field.fields; track field) {
                    <div class="wb-field">
                      @if (field.type !== 'collapse' &&
                        (field.type === 'select' || (formGroup.controls[field.property]?.value !== 0 && formGroup.controls[field.property]?.value !== ''))) {
                        <div class="wb-name"
                          >
                          {{field.label | translate | ucFirst}}
                        </div>
                      }
                      <app-field-value [field]="field" [form]="form" [formGroup]="formGroup"></app-field-value>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
        @if (parts[partIndex]?.returnIndex && formGroup.controls.returnTrip?.value) {
          <div class="wb-chapter wb-open wb-chapter-return wb-{{parts[partIndex]?.type}}"
            >
            <h4>{{ 'return_trip' | translate | ucFirst }}</h4>
            <div class="wb-fields">
              <div class="wb-field">
                <div class="wb-name">{{(returnDepartureField?.label ? $safeNavigationMigration(returnDepartureField?.label) : $safeNavigationMigration(returnDepartureField?.placeholder)) | translate | ucFirst}}</div>
                <app-field-value [field]="returnDepartureField" [form]="form" [formGroup]="formGroup"></app-field-value>
              </div>
              <div class="wb-field">
                <div class="wb-name">{{(returnDestinationField?.label ? $safeNavigationMigration(returnDestinationField?.label) : $safeNavigationMigration(returnDestinationField?.placeholder)) | translate | ucFirst}}</div>
                <app-field-value [field]="returnDestinationField" [form]="form" [formGroup]="formGroup"></app-field-value>
              </div>
              @for (field of parts[parts[partIndex]?.returnIndex]?.fields; track field) {
                <div class="wb-field">
                  @if (field.type !== 'collapse' &&
                    (field.type !== 'sortable-address' || formGroup.controls[field.property]?.value.length > 0) &&
                    (formGroup.controls[field.property]?.value !== 0 && formGroup.controls[field.property]?.value !== '')) {
                    <div class="wb-name"
                      >
                      {{(field.label ? field.label : field.placeholder) | translate | ucFirst}}
                    </div>
                  }
                  @if (field.type !== 'collapse' && formGroup.controls[field.property]?.value !== 0 &&
                    formGroup.controls[field.property]?.value !== '') {
                    <div>
                      <app-field-value [field]="field" [form]="form" [formGroup]="formGroup"></app-field-value>
                    </div>
                  }
                  @for (field of field.fields; track field) {
                    <div class="wb-field">
                      @if (field.type !== 'collapse' &&
                        (field.type === 'select' || (formGroup.controls[field.property]?.value !== 0 && formGroup.controls[field.property]?.value !== ''))) {
                        <div class="wb-name"
                          >
                          {{field.label | translate | ucFirst}}
                        </div>
                      }
                      <app-field-value [field]="field" [form]="form" [formGroup]="formGroup"></app-field-value>
                    </div>
                  }
                </div>
              }
              @for (field of returnLegFields(partIndex); track field) {
                <div class="wb-field">
                  <div class="wb-name">{{(field.label ? field.label : field.placeholder) | translate | ucFirst}}</div>
                  <app-field-value [field]="field" [form]="form" [formGroup]="formGroup"></app-field-value>
                </div>
              }
            </div>
          </div>
        }
      }
    </div>

    <div class="wb-dialog-summary-footer">
      <button class="wb-button-small {{buttonstyle === 'squared' ? 'wb-squared' : ''}}" (click)="modalService.getModal(summaryDialogId).close()">
        {{ 'close' | translate | ucFirst }}
      </button>
    </div>
  </ngx-smart-modal>
